/**
 * BottomNav — 모바일 하단 탭 네비게이션
 *
 * Phone에서 표시, Tablet/Desktop에서 숨김.
 * Small Phone: 아이콘만 / Large Phone: 아이콘+라벨.
 */

import { NavLink } from 'react-router'
import { STUDIO_NAV_ITEMS } from './navItems.js'
import styles from './BottomNav.module.css'

export function BottomNav() {
  return (
    <nav className={styles.root}>
      {STUDIO_NAV_ITEMS.map(({ to, label, icon: Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            `${styles.item} ${isActive ? styles.active : ''}`
          }
        >
          <Icon size={22} strokeWidth={1.8} className={styles.icon} />
          <span className={styles.label}>{label}</span>
        </NavLink>
      ))}
    </nav>
  )
}
